/**
 * Las imágenes del catálogo viven en Google Drive. El usuario pega la URL
 * compartida (https://drive.google.com/file/d/ID/view?usp=drive_link) y aquí
 * se convierte al CDN de contenido: lh3.googleusercontent.com/d/ID=s0.
 *
 * Se usa lh3 y no drive.google.com/uc porque este último responde con el
 * header "Content-Security-Policy: sandbox", que impide a los navegadores
 * renderizar la imagen inline en <img>.
 *
 * Requisito del lado de Drive: el archivo debe estar compartido como
 * "Cualquier persona con el enlace", si no Google devuelve su login.
 */

const DRIVE_HOST = /drive\.google\.com|docs\.google\.com|googleusercontent\.com/;

const DRIVE_ID_PATTERNS = [
  /\/file\/d\/([a-zA-Z0-9_-]+)/,
  /[?&]id=([a-zA-Z0-9_-]+)/,
  /lh3\.googleusercontent\.com\/d\/([a-zA-Z0-9_-]+)/,
];

export function isDriveUrl(url) {
  return typeof url === 'string' && DRIVE_HOST.test(url);
}

/**
 * Devuelve la URL directa de la imagen, o null si no se encontró un ID de
 * Drive en la URL.
 */
export function toDirectDriveUrl(url) {
  if (typeof url !== 'string' || !url.trim()) return null;
  const trimmed = url.trim();
  for (const pattern of DRIVE_ID_PATTERNS) {
    const match = trimmed.match(pattern);
    if (match) return `https://lh3.googleusercontent.com/d/${match[1]}=s0`;
  }
  return null;
}
